import theme from 'config/theme';

export default {
  wrapper: {
    '& .MuiInputLabel-root[data-shrink="true"]': {
      top: 0,
      color: theme.palette.grays.gray300,
    },

    '& .MuiAutocomplete-root': {
      padding: 0,
      '& .MuiOutlinedInput-root': {
        padding: '0px !important',
      },
    },
    '& .MuiAutocomplete-listbox': {
      padding: '4px',
      margin: 0,
    },
    '& .MuiAutocomplete-popper': {
      minWidth: '400px',
    },

    '& .MuiInputBase-input': {
      fontSize: '0.875rem',
      padding: '14px 0 16px 0!important',
    },
    '& .MuiAutocomplete-paper': {
      backgroundColor: '#fff',

      li: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        padding: '6px 12px !important',
        cursor: 'pointer',
        transition: 'background-color 0.15s',
        backgroundColor: 'transparent !important',
        borderRadius: '6px',
        marginBottom: '0 !important',
        fontSize: '0.875rem',
        fontWeight: 400,
        color: `${theme.palette.text.primary} !important`,
        '&.Mui-focused': {
          backgroundColor: `${theme.palette.grays?.gray100} !important`,
          color: `${theme.palette.text.primary} !important`,
          span: {
            color: `${theme.palette.text.primary} !important`,
          },
        },
        '&[aria-selected="true"]': {
          backgroundColor: `${theme.palette.grays?.gray100} !important`,
          color: `${theme.palette.text.primary} !important`,
          '&.Mui-focused': {
            backgroundColor: `${theme.palette.grays?.gray100} !important`,
            color: `${theme.palette.text.primary} !important`,
            span: {
              color: `${theme.palette.text.primary} !important`,
            },
          },
        },
        '&:hover': {
          backgroundColor: `${theme.palette.grays?.gray100} !important`,
          color: `${theme.palette.text.primary} !important`,
        },
      },
    },
    '& .MuiPaper-root': {
      boxShadow: 'none',
    },
    '& .MuiAutocomplete-clearIndicator': {
      svg: { width: '14px' },
      color: theme.palette.grays.gray700,
      '&:hover': {
        background: 'none',
      },
    },
  },
  location: {
    width: '100%',
    minWidth: '180px',
    border: 0,
    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: 0,
      border: 'none',
      padding: 0,
      legend: {
        fontSize: '0.875rem',
      },
    },
  },

  erfuddChip: {
    backgroundColor: theme.palette.greens.green200,
    color: theme.palette.greens.green900,
    fontWeight: 700,
    lineHeight: '1rem',
  },
};
